import { atom, useAtom } from 'jotai';
import { useCallback } from 'react';
import { produce } from 'immer';
import { v4 as uuidv4 } from 'uuid';
import { useStoreTemplateRefreshFn } from '@knowledge/knowledges/general/edit/hook';
import { newKnowledge } from '../knowledge';
import { Store } from 'components/StoreScopes';

type knowledgeConfigurationAtom = {
  visible: boolean;
  mode: 'add' | 'edit';
  knowledge: Knowledge.FormValue;
  storeDataSource?: Store[];
  id: string;
  drawerIndex: number;
}[];

export const knowledgeConfiguration = atom<knowledgeConfigurationAtom>([]);

// 时间默认值的问题，需要在这里处理
function fix(dtScope: Knowledge.Condition['dtScope']) {
  if (dtScope.dayRepeat?.length === 0) {
    dtScope.dayRepeat = [
      {
        timeRanges: [],
      },
    ];
  }
  if (dtScope.yearRepeat?.length === 0) {
    dtScope.yearRepeat = [
      {
        dtRanges: [],
      },
    ];
  }

  return dtScope;
}

function extractKnowledge(knowledge: any) {
  const { id, content, templateCode, ...others } = knowledge;
  const { dtScope, ...dontNeedFix } = others;
  return {
    ...(id && { id }),
    conditions: [{ ...dontNeedFix, dtScope: fix(dtScope) }],
    contentValue: {
      content,
      templateCode,
    },
  };
}

export const useKnowledgeConfiguration = () => {
  const [state, setState] = useAtom(knowledgeConfiguration);
  const storeFn = useStoreTemplateRefreshFn();

  const open = useCallback(
    (props?: { data: Knowledge.FormValue; refreshFn?: () => void }, stores?: Store[]) => {
      setState(
        produce((draft) => {
          draft.push({
            visible: false,
            mode: props?.data ? 'edit' : 'add',
            knowledge: props?.data ? extractKnowledge(props.data) : newKnowledge(),
            id: uuidv4(),
            drawerIndex: draft.length,
            storeDataSource: stores,
          });
        }),
      );

      storeFn(props?.refreshFn);

      setTimeout(() => {
        setState(
          produce((draft) => {
            // eslint-disable-next-line no-param-reassign
            draft[draft.length - 1].visible = true;
          }),
        );
      });
    },
    // eslint-disable-next-line
    [],
  );

  const close = useCallback(() => {
    setState(
      produce((draft) => {
        draft.splice(-1);
      }),
    );
    // eslint-disable-next-line
  }, []);
  return {
    kc: state,
    open,
    close,
  };
};
